import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { TemplateTextService } from 'tnx-admin-service/templatetext/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, GridInfo, ModelSchema } from 'tnx-shared';
@Component({
    selector: 'templatetext',
    templateUrl: './templatetext.component.html',
    styleUrls: ['./templatetext.component.scss'],
    providers: [ComponentContextService],
})
export class TemplateTextComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _templateTextService: TemplateTextService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._templateTextService;
        this.setting.modelSchemas = [
            new ModelSchema({ field: 'code', name: 'Mã', fullName: '', description: '' }),
            new ModelSchema({ field: 'title', name: 'Tên biểu mẫu', fullName: '', description: '' }),
            new ModelSchema({ field: 'content', name: 'Nội dung', fullName: '', description: '' }),
            new ModelSchema({ field: 'templateContentType', name: 'Loại biểu mẫu', fullName: '', description: '' }),
            new ModelSchema({ field: 'codeModule', name: 'Thuộc phân hệ', fullName: '', description: '' }),
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'code', fullTextSearch: true }),
            new ColumnSchemaBase({ field: 'title', fullTextSearch: true }),
            new ColumnSchemaBase({ field: 'templateContentType', dataType: 'templateContentType' }),
            new ColumnSchemaBase({ field: 'codeModule' }),
        ];

        this.setting.objectName = 'biểu mẫu text';
        this.setting.popupSize.width = 950;
        this.setting.popupSize.height = 750;
        super.ngOnInit();
    }

    async modifyGridInfo(gridInfo: GridInfo) {
        if (gridInfo.sorts.length == 0) {
            gridInfo.sorts.unshift(
                this.newSort('created', -1)
            );
        }
    }
}

